import { render, staticRenderFns } from "./GoodsBargain.vue?vue&type=template&id=2188a415"
import script from "./GoodsBargain.vue?vue&type=script&lang=js"
export * from "./GoodsBargain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports